import {doDispatch} from "../Dispatcher";
import {login, register} from "../../services/self";
import {confirmMarketplaceSubscription} from "../../services/api-catalog";

export const ActionTypes = {
    SUBSCRIPTION_REQUEST_RECEIVED: 'SUBSCRIPTION_REQUEST_RECEIVED',
    SELECT_AUTHENTICATION_MODAL_TYPE: 'SELECT_AUTHENTICATION_MODAL_TYPE',
    AUTHENTICATING: 'AUTHENTICATING',
    AUTHENTICATION_INPUT_RECEIVED: 'AUTHENTICATION_INPUT_RECEIVED',
    AUTHENTICATION_SUCCESS: 'AUTHENTICATION_SUCCESS',
    AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
    SUBSCRIBING: 'SUBSCRIBING',
    SUBSCRIPTION_SUCCESS: 'SUBSCRIPTION_SUCCESS',
    SUBSCRIPTION_FAILED: 'SUBSCRIPTION_FAILED',
    PRIVACY_ACCEPT_CHANGED: 'PRIVACY_ACCEPT_CHANGED'
};

export function subscriptionRequestReceived(token, isAuthenticated, authenticationModalType) {
    doDispatch({
        type: ActionTypes.SUBSCRIPTION_REQUEST_RECEIVED,
        token: token,
        isAuthenticated: isAuthenticated,
        authenticationModalType: authenticationModalType
    });
}

export function formReceivedUserInput(event, inputProps) {
    doDispatch({
        type: ActionTypes.AUTHENTICATION_INPUT_RECEIVED,
        formFieldName: inputProps.name,
        formFieldValue: inputProps.value
    });
}

export function privacyAcceptChanged(event, props) {
    doDispatch({
        type: ActionTypes.PRIVACY_ACCEPT_CHANGED,
        privacyAccepted: props.checked
    })
}

export function submitRegistration(email, password, company) {
    doDispatch({
        type: ActionTypes.AUTHENTICATING,
        message: `Registering ${email}...`
    });

    try {
        let registerPromise = register(email, password, company);
        registerPromise.then(() => {
            doDispatch({
                type: ActionTypes.AUTHENTICATION_SUCCESS
            });
        }).catch((e) => {
            doDispatch({
                type: ActionTypes.AUTHENTICATION_FAILED,
                message: e.message
            });
        })
    } catch (e) {
        doDispatch({
            type: ActionTypes.AUTHENTICATION_FAILED,
            message: e.message
        });
    }
}

export function submitLogin(email, password) {
    doDispatch({
        type: ActionTypes.AUTHENTICATING,
        message: `Logging in...`
    });

    try {
        const loginPromise = login(email, password);

        loginPromise.then(() => {
            doDispatch({
                type: ActionTypes.AUTHENTICATION_SUCCESS
            });
        }).catch((e) => {
            doDispatch({
                type: ActionTypes.AUTHENTICATION_FAILED,
                message: e.message
            });
        })
    } catch (e) {
        doDispatch({
            type: ActionTypes.AUTHENTICATION_FAILED,
            message: e.message
        });
    }
}

export function subscribe(token) {
    doDispatch({
        type: ActionTypes.SUBSCRIBING,
        message: "Subscribing..."
    });

    function success(data) {
        doDispatch({
            type: ActionTypes.SUBSCRIPTION_SUCCESS,
            message: "You have been subscribed successfully..."
        });
    }

    function error(err) {
        // sendLogEvent({
        //     token: token,
        //     payload: {
        //         source: "SUBSCRIPTION_FAILED",
        //         reason: err.message
        //
        //     }
        // });
        doDispatch({
            type: ActionTypes.SUBSCRIPTION_FAILED,
            message: "Error subscribing"
        });
    }

    try {
        const confirmMarketplaceSubscriptionPromise = confirmMarketplaceSubscription(token, error, success);
    } catch (e) {
        console.error("error from try", e);
        doDispatch({
            type: ActionTypes.SUBSCRIPTION_FAILED,
            message: e.message
        })
    }
}

export function selectAuthenticationModalType(authenticationModalType) {
    doDispatch({
        type: ActionTypes.SELECT_AUTHENTICATION_MODAL_TYPE,
        authenticationModalType: authenticationModalType
    });
}




/** WEBPACK FOOTER **
 ** ./src/shared_states/SubscriptionRequest/Actions.js
 **/